import React, { useContext, useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './DuplicateBlockWrapper.css';
import { getBlockDarkerColor } from '../../../helpers/color';
import GridContext from '../Grid/GridContext';
import DuplicateBlockControls from '../DuplicateBlockControls/DuplicateBlockControls';

const DuplicateBlockWrapper = forwardRef(({
  brightenBackground = false,
  brighterColor,
  children,
  color,
  increment = 1,
  nodeHeight,
  onAddClick,
  onDelete,
  readonly = false,
  showIncrement = false,
  total = 1,
}, ref) => {
  const grid = useContext(GridContext);
  const borderColor = useMemo(() => getBlockDarkerColor(color, 0.4), [color]);

  const wrapperStyle = useMemo(() => ({
    backgroundColor: brightenBackground ? brighterColor : color,
    borderColor,
    height: (nodeHeight * grid.rowHeight) - 8,
  }), [nodeHeight, grid, borderColor, brightenBackground, color, brighterColor]);

  return (
    <div ref={ref} className={styles.DuplicateBlockWrapper} style={wrapperStyle}>
      <DuplicateBlockControls
        color={color}
        showIncrement={showIncrement}
        increment={increment}
        total={total}
        onAddClick={onAddClick}
        onDelete={onDelete}
        readonly={readonly}
      />
      {children}
    </div>
  );
});

DuplicateBlockWrapper.displayName = 'DuplicateBlockWrapper';

DuplicateBlockWrapper.propTypes = {
  brightenBackground: PropTypes.bool,
  brighterColor: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string.isRequired,
  increment: PropTypes.number,
  nodeHeight: PropTypes.number,
  onAddClick: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
  showIncrement: PropTypes.bool,
  total: PropTypes.number,
};

export default DuplicateBlockWrapper;
